import React from 'react';
import clsx from 'clsx';

import { HexTile, Accordion } from '@/components';
import Button from '@/components/Button';
import { isBrowser, isMobile } from 'react-device-detect';

import getFullName from '@/lib/helpers/getFullName';

import editPretile from '@/assets/icons/edit-pretile.svg';
import { saveVcf } from '@/lib/helpers/vcf';
import { useToggle } from '@/hooks';
import VirtualCard from '@/components/VirtualCard';
import Icon from '@/components/Icon';
import './ExchangeProfileBlock.scss';

import apple from '@/assets/images/apple.png';
import google from '@/assets/images/google_play.png';

const ExchangeProfileBlock = ({
    data,
    isHeader = false,
    handleLongPress = () => { },
    isEdit = false,
    onEdit = () => { },
    children
}) => {
    const user = data?.user
    const emailField = data?.level?.fields?.find(
        field => field.label === 'Email: Professional'
    );

    const photoField = data?.level?.fields?.find(
        field => field.label === 'Profile Photo'
    );

    const downloadCard = src => {
        const img = new Image();
        img.crossOrigin = 'anonymous';
        img.src = src;
        img.onload = () => {
            const canvas = document.createElement('canvas');
            const ctx = canvas.getContext('2d');
            canvas.width = img.width;
            canvas.height = img.height;
            ctx.drawImage(img, 0, 0);
            const a = document.createElement('a');
            a.download = 'download.png';
            a.href = canvas.toDataURL('image/png');
            a.click();
        };
    };
    const [isModalOpen, { setTrue: openModal, setFalse: closeModal }] =
        useToggle();

    const email = emailField?.value;
    return (
        <div className='exchange-info-block'>
            {isHeader && (<div className='tile-container' {...handleLongPress()}>
                <div className='spacer' />
                <HexTile
                >
                    <HexTile.Image src={photoField ? photoField?.value : user.avatar_url} />
                </HexTile>
                <div className='spacer'>
                    {isEdit && (
                        <img src={editPretile} className='edit' onClick={onEdit} />
                    )}
                </div>
            </div>)}
            {children ? (
                { ...children }
            ) : (
                <>
                    <center className='name-1'>{getFullName(user)}</center>
                    <center className='email'>{email}</center>
                </>
            )}
            {data.user.card_photo_url ? (
                // <Accordion>
                //     <Accordion.ListHeader>Business Card Photo</Accordion.ListHeader>
                //     <Accordion.Body>
                //         <div className='business-card-section'>
                //             <VirtualCard imageUrl={data.user.card_photo_url} />
                //             <div
                //                 className={clsx(
                //                     'button-container',
                //                     isMobile && '-mobile',
                //                     isBrowser && '-browser'
                //                 )}
                //             >
                //                 <Button
                //                     icon={<Icon name='save' className='icon' />}
                //                     size='large'
                //                     onClick={() =>
                //                         downloadCard(data.user.card_photo_url)
                //                     }
                //                 >
                //                     Save Card
                //                 </Button>
                //                 <Button
                //                     icon={<Icon name='zoom_in' className='icon' />}
                //                     size='large'
                //                     onClick={openModal}
                //                 >
                //                     Zoom In
                //                 </Button>
                //             </div>
                //         </div>
                //     </Accordion.Body>
                // </Accordion>
                <div className='business-card-section'>
                    <a href={`mailto:${data.user.email}`}>
                        <button className='send-email'>Send Email</button>
                    </a>
                    <VirtualCard imageUrl={data.user.card_photo_url} />
                    {/* <div
                        className={clsx(
                            'button-container',
                            isMobile && '-mobile',
                            isBrowser && '-browser'
                        )}
                    >
                        <Button
                            icon={<Icon name='save' className='icon' />}
                            size='large'
                            onClick={() =>
                                downloadCard(data.user.card_photo_url)
                            }
                        >
                            Save Card
                        </Button>
                        <Button
                            icon={<Icon name='zoom_in' className='icon' />}
                            size='large'
                            onClick={openModal}
                        >
                            Zoom In
                        </Button>
                    </div> */}
                </div>
            ) : (<a href={`mailto:${data.user.email}`}>
                <button className='send-email'>Send Email</button>
            </a>)}
            {isMobile && (<div className='download-container'>
                <Button
                    size='large'
                    onClick={() => saveVcf(data, window.location.href)}
                >
                    Contact Download (VCF/CSV)
                </Button>
            </div>)}
            <p className='app-store-text'>App Stores</p>
            <div className='app-icons-container flex'>
                <a href='https://play.google.com/store/apps/details?id=io.synthnode_app' target='_blank'>
                    <img src={google} />
                </a>
                <a href='https://apps.apple.com/ca/app/synthnode/id6761746074' target='_blank'>
                    <img src={apple} />
                </a>
            </div>
            {
                isModalOpen && (
                    <div className='modal-background'>
                        <div className='modal'>
                            <div className='header'>
                                <button onClick={closeModal}>
                                    <span className='material-symbols-outlined icon'>close</span>
                                </button>
                            </div>
                            <div className='body'>
                                <TransformWrapper>
                                    <TransformComponent>
                                        <VirtualCard
                                            imageUrl={exchangeProfile?.user.card_photo_url}
                                        />
                                    </TransformComponent>
                                </TransformWrapper>
                            </div>
                        </div>
                    </div>
                )
            }
        </div>
    );
};

export default ExchangeProfileBlock;
